import { render, staticRenderFns } from "./Zzjg.vue?vue&type=template&id=ec930e74&scoped=true&"
import script from "./Zzjg.vue?vue&type=script&lang=js&"
export * from "./Zzjg.vue?vue&type=script&lang=js&"
import style0 from "./Zzjg.vue?vue&type=style&index=0&id=ec930e74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec930e74",
  null
  
)

export default component.exports